import { SxProps } from "@mui/material/styles";

export const waitingOverlayText: SxProps = {
  whiteSpace: "pre",
  textAlign: "left",
  padding: 2,
  borderRadius: 2,
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  borderTop: "4px solid #49a3f1",
  color: "#383838",
  boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",

  "&::after": {
    content: '"\u00A0\u00A0\u00A0"',
    animation: "progress-ellipsis 1s infinite",
  },
  "@keyframes progress-ellipsis": {
    "0%": {
      content: '"\u00A0\u00A0\u00A0"',
    },
    "25%": {
      content: '".\u00A0\u00A0"',
    },
    "50%": {
      content: '"..\u00A0"',
    },
    "100%": {
      content: '"..."',
    },
  },
};
